import type { Lang } from "@majourneys/shared";

export interface BlogFilters {
  page?: number;
  category?: string;
  search?: string;
}

export const blogKeys = {
  all: ["blog"] as const,
  list: (lang: Lang, filters?: BlogFilters) =>
    [...blogKeys.all, "list", lang, filters] as const,
  detail: (lang: Lang, slug: string) => [...blogKeys.all, "detail", lang, slug] as const,
  recent: (lang: Lang) => [...blogKeys.all, "recent", lang] as const,
};
